module.exports = __webpack_public_path__ + "static/graph-a74fa20a548768aeb9448ed4fb942148.png";